module.exports = __webpack_public_path__ + "img/navbar-checklist2.83ae3f47.png";